// extracted by mini-css-extract-plugin
export var discography = "HomeDisks-module--discography--9shOy";
export var discography_header = "HomeDisks-module--discography_header--VSpX0";
export var discography_title = "HomeDisks-module--discography_title--RiGMV";
export var discography_more_button = "HomeDisks-module--discography_more_button--KK72k";
export var icon = "HomeDisks-module--icon--XK2-y";
export var discography_content = "HomeDisks-module--discography_content--F4QFH";
export var last_disk = "HomeDisks-module--last_disk--1aXJO";
export var all_disk = "HomeDisks-module--all_disk--vsEGR";
export var small_card = "HomeDisks-module--small_card--sgj7K";